import { render, staticRenderFns } from "./VehicleTrimBotSubmitComponent.vue?vue&type=template&id=68a959f4"
import script from "./VehicleTrimBotSubmitComponent.vue?vue&type=script&lang=ts"
export * from "./VehicleTrimBotSubmitComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports